import { GetterTree } from 'vuex';
import { AuthState } from '../types';
import { RootState } from '@/store/types';
import { BALANCE,
        USERNAME,
        USER_ID,
        FULLNAME,
        GET_LOGIN_ERROR,
        IS_LOGGED_IN,
        LOADING_LOGIN,
        ACCOUNT_ID,
        EMAIL,
        USER_REAL_ID,
        ACCOUNT
} from '@/modules/auth/store/constants';

const getters: GetterTree<AuthState, RootState> = {
    [FULLNAME](state: AuthState): string {
        const { user } = state;
        return ``;
    },
    [USER_REAL_ID](state: AuthState): string {
        const { user } = state;
        return user ? `users/${user.id}` : '';
    },
    [USER_ID](state: AuthState): string {
        const { user } = state;
        return user ? `users/${user.username}` : '';
    },
    [ACCOUNT_ID](state: AuthState): string {
        const { user } = state;
        return user ? user.accountId : '';
    },
    [EMAIL](state: AuthState): string {
        const { user } = state;
        return user ? user.email : '';
    },
    [USERNAME](state: AuthState): string {
        const { user } = state;
        return user ? user.username : '';
    },
    [IS_LOGGED_IN](state: AuthState): boolean {
        return !!state.token;
    },
    [BALANCE](state: AuthState): number {
        const { user } = state;
        return (user && parseFloat(user.money.amount)) || 0;
        // return balance + (user && user.money.currency === 'EUR' ? '€' : '$') || '€';
    },
    [GET_LOGIN_ERROR](state: AuthState): boolean {
        return state.error;
    },
    [LOADING_LOGIN](state: AuthState): boolean {
        return state.loading;
    },
    [BALANCE](state: AuthState): string {
        if (!state.account) {
            return "0"
        }
        // @ts-ignore
        return state.account.moneyAmount;
    },
};

export default getters;
